 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056":"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056","articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75":"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75","articoli~media":"articoli~media","articoli":"articoli","camere":"camere","categorie":"categorie","clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca":"clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca","clienti~usato-clienti":"clienti~usato-clienti","clienti":"clienti","usato-clienti":"usato-clienti","magazzino-accessori":"magazzino-accessori","magazzino-smartphones":"magazzino-smartphones","movimenti":"movimenti","note":"note","registro-generale":"registro-generale","storico-vendite":"storico-vendite","magazzino-formazione":"magazzino-formazione","magazzino-ricambi":"magazzino-ricambi","magazzino-servizi":"magazzino-servizi","magazzino-sims":"magazzino-sims","preordini":"preordini","riparazioni-bytewood":"riparazioni-bytewood","riparazioni-clienti":"riparazioni-clienti","strumenti-di-contabilita":"strumenti-di-contabilita","media":"media","gestione-accessori":"gestione-accessori","profilo":"profilo"}[chunkId]||chunkId) + "." + {"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056":"9107f7e0","articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75":"4ce802f5","articoli~media":"9560e486","articoli":"67420ef8","camere":"108cef66","categorie":"916cae24","clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca":"03adfdab","clienti~usato-clienti":"9119b25f","clienti":"57465fbd","usato-clienti":"54031dda","magazzino-accessori":"d379d0d4","magazzino-smartphones":"695fe257","movimenti":"5f97e6a0","note":"43f6aa4d","registro-generale":"1d9b8664","storico-vendite":"8c4999c4","magazzino-formazione":"8d8927b7","magazzino-ricambi":"e55e1a08","magazzino-servizi":"c8f5c4bf","magazzino-sims":"11160b6c","preordini":"e740f6c1","riparazioni-bytewood":"e589bb0e","riparazioni-clienti":"734d1406","strumenti-di-contabilita":"64e66eec","media":"af2c0419","gestione-accessori":"9e3e4b09","profilo":"2cbaaa17"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056":1,"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75":1,"articoli~media":1,"articoli":1,"camere":1,"categorie":1,"clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca":1,"clienti~usato-clienti":1,"clienti":1,"usato-clienti":1,"magazzino-accessori":1,"magazzino-smartphones":1,"movimenti":1,"note":1,"registro-generale":1,"storico-vendite":1,"magazzino-formazione":1,"magazzino-ricambi":1,"magazzino-servizi":1,"magazzino-sims":1,"preordini":1,"riparazioni-bytewood":1,"riparazioni-clienti":1,"strumenti-di-contabilita":1,"media":1,"profilo":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056":"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056","articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75":"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75","articoli~media":"articoli~media","articoli":"articoli","camere":"camere","categorie":"categorie","clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca":"clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca","clienti~usato-clienti":"clienti~usato-clienti","clienti":"clienti","usato-clienti":"usato-clienti","magazzino-accessori":"magazzino-accessori","magazzino-smartphones":"magazzino-smartphones","movimenti":"movimenti","note":"note","registro-generale":"registro-generale","storico-vendite":"storico-vendite","magazzino-formazione":"magazzino-formazione","magazzino-ricambi":"magazzino-ricambi","magazzino-servizi":"magazzino-servizi","magazzino-sims":"magazzino-sims","preordini":"preordini","riparazioni-bytewood":"riparazioni-bytewood","riparazioni-clienti":"riparazioni-clienti","strumenti-di-contabilita":"strumenti-di-contabilita","media":"media","gestione-accessori":"gestione-accessori","profilo":"profilo"}[chunkId]||chunkId) + "." + {"articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~658bd056":"8f3c58d4","articoli~camere~categorie~clienti~magazzino-accessori~magazzino-formazione~magazzino-ricambi~magazzi~9ad14f75":"5c751f86","articoli~media":"8a228908","articoli":"1aa0ed02","camere":"c644aff1","categorie":"076aca51","clienti~magazzino-accessori~magazzino-smartphones~movimenti~note~registro-generale~storico-vendite~u~90f7aaca":"d1564595","clienti~usato-clienti":"5e3bb80e","clienti":"62ca6bbf","usato-clienti":"cbb4c4d8","magazzino-accessori":"7807d29d","magazzino-smartphones":"44c2cf71","movimenti":"c5d94783","note":"f8391be1","registro-generale":"bda76de9","storico-vendite":"591f32a5","magazzino-formazione":"d7505bdd","magazzino-ricambi":"ff3109da","magazzino-servizi":"d7505bdd","magazzino-sims":"97502f00","preordini":"9728c4f2","riparazioni-bytewood":"f93abf83","riparazioni-clienti":"fe171632","strumenti-di-contabilita":"98f140d0","media":"c2d00760","gestione-accessori":"31d6cfe0","profilo":"82211a87"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
